// extracted by mini-css-extract-plugin
export default {"root":"Skeleton_root__+GfjR","line":"Skeleton_line__4A2J4","loading":"Skeleton_loading__ID0Ur","rounded":"Skeleton_rounded__rEDJP"};